import { render, staticRenderFns } from "./entitlement-period-has.vue?vue&type=template&id=2a98d42d"
import script from "./entitlement-period-has.vue?vue&type=script&lang=js"
export * from "./entitlement-period-has.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports